(function(){
  'use strict';

  function txt(el){ return (el && el.textContent ? el.textContent : '').replace(/\s+/g,' ').trim(); }

  function gallery(root){
    var main = root.querySelector('[data-ss-main]');
    var thumbs = root.querySelectorAll('[data-ss-thumb]');
    Array.prototype.forEach.call(thumbs, function(t){
      t.addEventListener('click', function(){
        if (main) main.src = t.getAttribute('data-src');
        Array.prototype.forEach.call(thumbs, function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  function qty(root){
    var box = root.querySelector('[data-ss-qty]');
    if (!box) return;
    var input = box.querySelector('input');
    var minus = box.querySelector('[data-minus]');
    var plus = box.querySelector('[data-plus]');
    if (minus) minus.addEventListener('click', function(){
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
    if (plus) plus.addEventListener('click', function(){
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  }

  // Move imported BigCommerce tab content into the panels as real DOM nodes,
  // so nesting stays balanced regardless of how the source markup is structured.
  function distribute(scope, host){
    if (!scope) return;
    var style = scope.querySelector('style');
    if (style && style.parentNode) style.parentNode.removeChild(style);

    var map = { overview: '#content1', specs: '#content2', features: '#content3', faq: '#content4' };
    var moved = false;

    Object.keys(map).forEach(function(key){
      var node = scope.querySelector(map[key]);
      var target = host.querySelector('[data-ss-body="' + key + '"]');
      if (node && target) { target.appendChild(node); moved = true; }
    });

    if (!moved) {
      var ov = host.querySelector('[data-ss-body="overview"]');
      if (ov) { while (scope.firstChild) { ov.appendChild(scope.firstChild); } }
    }
  }

  function specRows(host){
    var panel = host.querySelector('[data-ss-body="specs"]');
    if (!panel) return [];
    // Header rows use <th>, so requiring two <td> cells skips them automatically.
    return Array.prototype.slice.call(panel.querySelectorAll('tr')).map(function(tr){
      var cells = tr.querySelectorAll('td');
      if (cells.length < 2) return null;
      return { label: txt(cells[0]), value: txt(cells[1]) };
    }).filter(Boolean);
  }

  // Strips catalogue-data noise ("cat no- X", "range 0-15000 ppm") out of the imported
  // product title for display only — the real product.title / handle / SEO fields are
  // never touched. The captured range is reused in the subtitle instead of discarded.
  function cleanTitle(host){
    var el = host.querySelector('.ss-title');
    if (!el) return;
    var raw = txt(el);

    var rangeMatch = raw.match(/\brange\s+([\d,.]+\s*(?:-|to|–|—)\s*[\d,.]+\s*[a-zA-Zµ%\/]*)/i);

    var cleaned = raw
      .replace(/\bcat\.?\s*no\.?[\s:.-]*\S+/gi, '')
      .replace(/\brange\s+[\d,.]+\s*(?:-|to|–|—)\s*[\d,.]+\s*[a-zA-Zµ%\/]*/gi, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/[\s,.-]+$/, '')
      .trim();

    if (cleaned && cleaned.length > 2 && cleaned !== raw) el.textContent = cleaned;

    var sub = host.querySelector('[data-ss-subtitle]');
    if (!sub) return;
    var parts = [];
    var cat = sub.getAttribute('data-category');
    if (cat) parts.push(cat);
    if (rangeMatch) parts.push('Range ' + rangeMatch[1].replace(/\s+/g, ' ').trim());
    if (parts.length) {
      sub.textContent = parts.join(' · ');
    } else {
      sub.classList.add('ss-hidden');
    }
  }

  // Parsed once from the specs table, then rendered into every matching target
  // (tab pills, hero "Best suited for" chips, Overview quick-scan list).
  function parseApplications(rows){
    var hit = null;
    rows.forEach(function(r){ if (!hit && /^applications?\b/i.test(r.label)) hit = r; });
    if (!hit || !hit.value) return [];
    return hit.value.split(/[,;]/).map(function(s){ return s.trim(); }).filter(Boolean);
  }

  function renderApplications(host, list){
    var tabTarget = host.querySelector('[data-ss-apps]');
    if (list.length && tabTarget && !tabTarget.children.length) {
      list.forEach(function(label){
        var pill = document.createElement('span');
        pill.className = 'ss-app';
        pill.textContent = label;
        tabTarget.appendChild(pill);
      });
    }

    var bestforList = host.querySelector('[data-ss-bestfor-list]');
    if (list.length && bestforList && !bestforList.children.length) {
      list.slice(0, 5).forEach(function(label){
        var pill = document.createElement('span');
        pill.className = 'ss-bf';
        pill.textContent = label;
        bestforList.appendChild(pill);
      });
    }
    // Hide the hero "Best suited for" block whenever it ends up with nothing in it,
    // regardless of whether that's because there was no source data at all.
    var wrap = host.querySelector('[data-ss-bestfor]');
    if (wrap && bestforList && !bestforList.children.length) wrap.classList.add('ss-hidden');

    var ovList = host.querySelector('[data-ss-ov-apps]');
    if (list.length && ovList && !ovList.children.length) {
      list.slice(0, 5).forEach(function(label){
        var li = document.createElement('li');
        li.textContent = label;
        ovList.appendChild(li);
      });
    }
  }

  function chips(host, rows){
    var target = host.querySelector('[data-ss-chips]');
    if (!target) return;
    var want = 4 - target.children.length;
    if (want <= 0) return;

    var patterns = [/measurement range/i, /\brange\b/i, /accuracy/i, /resolution/i];
    var used = {};

    patterns.forEach(function(re){
      if (want <= 0) return;
      rows.forEach(function(r){
        if (want <= 0 || used[r.label] || !re.test(r.label)) return;
        if (!r.value || r.value.length > 44) return;
        used[r.label] = true;
        var chip = document.createElement('div');
        chip.className = 'ss-chip';
        var b = document.createElement('b');
        b.textContent = r.label;
        var s = document.createElement('span');
        s.textContent = r.value;
        chip.appendChild(b);
        chip.appendChild(s);
        target.appendChild(chip);
        want--;
      });
    });
  }

  // Only badge a standard when it is explicitly stated in the product copy.
  var STANDARDS = [
    { re: /\bUS\s?EPA\b|\bEPA[- ]?(compliant|approved|method)/i, label: 'USEPA method' },
    { re: /\bISO\s?7027\b/i, label: 'ISO 7027' },
    { re: /\bISO\s?9001\b/i, label: 'ISO 9001' },
    { re: /\bIP\s?6[5-8]\b/i, label: null },
    { re: /\bIP\s?5[4-6]\b/i, label: null },
    { re: /\bGLP\b/, label: 'GLP compliant' },
    { re: /\bcGMP\b/i, label: 'cGMP' },
    { re: /\bNABL\b/, label: 'NABL' },
    { re: /\bUSP\b/, label: 'USP' },
    { re: /automatic temperature compensation|\bATC\b/i, label: 'ATC' }
  ];

  function badges(host){
    var target = host.querySelector('[data-ss-badges]');
    if (!target || target.children.length) return;

    // Read only overview + specs: the FAQ panel carries a JSON-LD block that would
    // otherwise double-count terms without adding meaning.
    var source = txt(host.querySelector('[data-ss-body="overview"]')) + ' ' +
                 txt(host.querySelector('[data-ss-body="specs"]'));
    if (!source.trim()) return;

    var seen = {};
    var count = 0;

    STANDARDS.forEach(function(std){
      if (count >= 5) return;
      var m = source.match(std.re);
      if (!m) return;
      // IP-rating entries badge with whatever rating actually matched (IP67, IP54, ...).
      var label = std.label || m[0].toUpperCase().replace(/\s+/g, '');
      if (seen[label]) return;
      seen[label] = true;
      var el = document.createElement('span');
      el.className = 'ss-badge';
      el.textContent = label;
      target.appendChild(el);
      count++;
    });
  }

  // Feature titles are marked up inconsistently across the imported catalogue:
  // some products use <span class="feature-title">, others a leading <strong>,
  // others just text before an en-dash. Handle all three. Parsed once, rendered
  // into both the hero highlights list and the Overview quick-scan column.
  function parseHighlights(host){
    var features = host.querySelector('[data-ss-body="features"]');
    if (!features) return [];

    var items = features.querySelectorAll('ul.features-list li');
    if (!items.length) items = features.querySelectorAll('li');

    var picked = [];
    Array.prototype.forEach.call(items, function(li){
      if (picked.length >= 5) return;
      var lead = li.querySelector('.feature-title, strong, b');
      var label = lead ? txt(lead) : txt(li).split(/[–—-]/)[0];
      label = (label || '').replace(/[\s–—:-]+$/, '').trim();
      if (label && label.length > 2) picked.push(label.length > 72 ? label.slice(0, 69) + '…' : label);
    });

    return picked;
  }

  function renderHighlights(host, list){
    if (!list.length) return;

    var hero = host.querySelector('[data-ss-highlights]');
    if (hero && !hero.children.length) {
      list.forEach(function(label){
        var li = document.createElement('li');
        li.textContent = label;
        hero.appendChild(li);
      });
    }

    var ov = host.querySelector('[data-ss-ov-features]');
    if (ov && !ov.children.length) {
      list.forEach(function(label){
        var li = document.createElement('li');
        li.textContent = label;
        ov.appendChild(li);
      });
    }
  }

  // Hides the Overview quick-scan block (or just the empty half of it) when neither
  // Applications nor Key features had any source data.
  function overviewExtras(host){
    var wrap = host.querySelector('[data-ss-ov-extra]');
    if (!wrap) return;
    var cols = wrap.querySelectorAll('[data-ss-ov-col]');
    var anyVisible = false;
    Array.prototype.forEach.call(cols, function(col){
      var list = col.querySelector('ul');
      if (list && list.children.length) { anyVisible = true; }
      else { col.classList.add('ss-hidden'); }
    });
    if (!anyVisible) wrap.classList.add('ss-hidden');
  }

  function tabs(host){
    var buttons = Array.prototype.slice.call(host.querySelectorAll('[data-ss-tab]'));
    var visible = [];

    buttons.forEach(function(btn){
      var key = btn.getAttribute('data-ss-tab');
      var panel = host.querySelector('[data-ss-panel="' + key + '"]');
      if (!panel) { btn.classList.add('ss-hidden'); return; }

      var holders = panel.querySelectorAll('[data-ss-body],[data-ss-apps],[data-ss-content]');
      var hasContent = false;
      Array.prototype.forEach.call(holders, function(c){
        if (c.children.length || txt(c)) hasContent = true;
      });

      if (!hasContent) {
        btn.classList.add('ss-hidden');
        panel.classList.add('ss-hidden');
        return;
      }

      visible.push({ btn: btn, panel: panel });

      btn.addEventListener('click', function(){
        buttons.forEach(function(b){ b.classList.remove('is-active'); });
        Array.prototype.forEach.call(host.querySelectorAll('[data-ss-panel]'), function(p){ p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        panel.classList.add('is-active');
      });
    });

    if (visible.length) {
      visible[0].btn.classList.add('is-active');
      visible[0].panel.classList.add('is-active');
    }
  }

  function sticky(){
    var bar = document.querySelector('[data-ss-sticky]');
    var anchor = document.querySelector('.ss-buybox');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        // Show the bar only once the main buy panel has scrolled off the top.
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  function modal(){
    var box = document.querySelector('[data-ss-modal]');
    if (!box) return;
    var frame = box.querySelector('iframe[data-src]');

    function open(){
      if (frame && !frame.getAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-src'));
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-quote]'), function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); open(); });
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-ss-close]'), function(b){
      b.addEventListener('click', close);
    });
    box.addEventListener('click', function(e){ if (e.target === box) close(); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });
  }

  function init(){
    var host = document;
    var root = document.querySelector('[data-ss-product]');
    if (root) { gallery(root); qty(root); }

    var source = document.querySelector('[data-ss-source]');
    if (source) {
      distribute(source.content ? source.content : source, host);
      if (source.parentNode) source.parentNode.removeChild(source);
    }

    cleanTitle(host);

    var rows = specRows(host);
    var apps = parseApplications(rows);
    renderApplications(host, apps);
    chips(host, rows);
    badges(host);
    var feats = parseHighlights(host);
    renderHighlights(host, feats);
    overviewExtras(host);
    tabs(host);
    sticky();
    modal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
